import { render } from "./BtnImgs.vue?vue&type=template&id=3eb668a4&scoped=true"
import script from "./BtnImgs.vue?vue&type=script&lang=js"
export * from "./BtnImgs.vue?vue&type=script&lang=js"

import "./BtnImgs.vue?vue&type=style&index=0&id=3eb668a4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb668a4"]])

export default __exports__